import { render } from "./UpsertIconButtonWithSearch.vue?vue&type=template&id=52e4bbc0"
import script from "./UpsertIconButtonWithSearch.vue?vue&type=script&lang=js"
export * from "./UpsertIconButtonWithSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__